export default __webpack_public_path__ + "static/media/1764.786278c4.png";